import { render, staticRenderFns } from "./commonTip.vue?vue&type=template&id=d09b2274&scoped=true&"
import script from "./commonTip.vue?vue&type=script&lang=js&"
export * from "./commonTip.vue?vue&type=script&lang=js&"
import style0 from "./commonTip.vue?vue&type=style&index=0&id=d09b2274&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09b2274",
  null
  
)

export default component.exports